export function parseForSearch(vin) {
    return vin.replaceAll('/', '-');
}
